<template>
    <mx-panel v-if='!IsDelete && value' :type='config.Type' panel='SystemList' :value='value' :config='Config'
        :index='index' @event="OnEvent">
        <div slot='button' slot-scope="scope" v-if="scope.handle" class="flex-row start wrap list-half">
            <div v-if="!scope.handle.GetDisabled('modify')">
                <a class="button" href="javascript:void(0)" @click="scope.handle.OnModify">编辑</a>
            </div>
            <div v-if="!scope.handle.GetDisabled('del')">
                <a class="button" href="javascript:void(0)" @click="scope.handle.OnDelete">删除</a>
            </div>
        </div>
        <div v-if='IsModify' class="modifyed">
            <div>数据已经发生变化，请重新刷新页面</div>
        </div>
    </mx-panel>
</template>
<script>
export default {
    props: {
        config: Object,
        value: Object,
        index: Number,
        role: String,
        roleField: String,
        name: String
    },
    data() {
        return { IsModify: false, IsDelete: false }
    },
    computed: {
        Config() {
            return Object.assign({ EventName: this.name ? this.name : 'TypeEvent', IsDark: false }, this.config)
        }
    },
    methods: {
        OnEvent(e) {
            this.$emit('event', e)
        }
    }
}
</script>
<style>
 /deep/.el-dialog__wrapper .el-dialog {
  background: #0b2846 !important;
}
</style>
